import Joi, { ErrorReport } from 'joi';

import { removeWhiteSpaces } from 'helpers/string/string.helper';

export const isValidPhoneNumber = (value: string) => {
  const isPhoneRegex = /^\+[1-9]\d{2,14}$/;

  if (!value.match(isPhoneRegex)) return false;

  return true;
};

const isPhoneNumber = (
  value: string,
  helpers: Joi.CustomHelpers<unknown>
): string | ErrorReport => {
  if (!value) return value;
  const phoneNumberNoWhiteSpaces = removeWhiteSpaces(value);

  if (!isValidPhoneNumber(phoneNumberNoWhiteSpaces)) {
    return helpers.error('any.invalid');
  }

  return phoneNumberNoWhiteSpaces;
};

export const phoneValidationStrategy = Joi.string().custom(isPhoneNumber);
